import { FormikProps } from "formik";
import { SignupRadioField } from "../SignupRadioField/SignupRadioField";
import { SignupStepButton } from "../SignupStepButton/SignupStepButton";
import { SignupSkipButton } from "../SignupSkipButton/SignupSkipButton";
import { Loader } from "@/components/Common/Loader/Loader";
import { ROLE_OPTIONS, RoleStepFormType } from "../RoleStepSlide/RoleStepSlide";
import { useEffect, useRef } from "react";

type RoleStepSlideFormProps = FormikProps<RoleStepFormType> & { onPrev?: () => void };

export const RoleStepSlideForm: React.FC<RoleStepSlideFormProps> = ({
  isValid,
  handleSubmit,
  isSubmitting,
  values
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const { role } = values;
    if (!role) {
      return;
    }

    buttonRef.current?.click();
  }, [values]);

  return (
    <form className="flex flex-1 flex-col items-center justify-center" onSubmit={handleSubmit}>
      <div className="flex w-[380px] flex-col gap-5 text-center">
        <h2 className="title-h4 text-white">
          Are You a GPU
          <br />
          Provider Or ML Engineer
        </h2>
        <div className="flex flex-col gap-2">
          {ROLE_OPTIONS.map(({ value, label }) => {
            return <SignupRadioField name="role" key={value} value={value} label={label} />;
          })}
          <p className="subtext-x-small text-gray-dark-1000">
            Note: a new window will open for you to connect Solana
          </p>
        </div>

        <div className="flex flex-row items-center gap-5">
          {/* <SignupStepButton onClick={onPrev}>Go back</SignupStepButton> */}
          <SignupStepButton
            ref={buttonRef}
            type="submit"
            className="flex-1"
            disabled={!isValid || isSubmitting}
          >
            Next Step
            {isSubmitting && <Loader className="!h-[14px] !w-[14px]" color="#fff" />}
          </SignupStepButton>
        </div>
        <div className="flex flex-row justify-center">
          <SignupSkipButton disabled={isSubmitting} />
        </div>
      </div>
    </form>
  );
};
